/**
 * Company: SPHMedia
 * Description: [UGC Landing page new logic: Display mata-mata stories]
 */

import AdsContainer from "@components/Blocks/Container/AdsContainer";
import { AdsLb2 } from "@elements/Advertisement/variant/AdsLb";
import { ProcessedArticleData } from "@transformer/useOSResponse";
import { PageAdTargetValue } from "@typings/Ads.d";
import { ReactElement } from "react";
import React from "react";

import { ArticleCardWrapper } from "./Component/ArticleCardWrapper";
import UGCStoriesInfiniteList from "./UGCStoriesInfiniteList";

type UGCStoriesListingProps = {
  data: ProcessedArticleData[];
  pageAdTargetValue: PageAdTargetValue;
};

/**
 * UGCStoriesListing
 * Description: [mata-mata stories listing on landing page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function UGCStoriesListing({
  data,
  pageAdTargetValue,
}: UGCStoriesListingProps): ReactElement {
  return (
    <>
      {data.map((context, index) => {
        const shouldDisplayAdAfterFirstRow = index === 1;

        // Insert the ad as a full row after 2 cards
        if (shouldDisplayAdAfterFirstRow) {
          return (
            <React.Fragment key="ads">
              <div className="flex mb-6 lg:mb-8 w-full gap-[22px]">
                <ArticleCardWrapper context={data[0]} />
                <ArticleCardWrapper context={data[1]} />
              </div>

              <div className="w-full">
                <AdsContainer className="flex justify-center border-b border-grey-850 mb-6 lg:mb-8">
                  <AdsLb2
                    uniqueSectionName="mata-mata"
                    pageAdTargetType={pageAdTargetValue}
                    hasStripeBg={false}
                  />
                </AdsContainer>
              </div>
            </React.Fragment>
          );
        }

        // After ad, continue rendering rows of 2 ArticleCards per row
        if (index > 2 && index % 2 === 1) {
          return (
            <div key={index} className="flex w-full mb-6 lg:mb-8 gap-[22px]">
              <ArticleCardWrapper context={data[index - 1]} />
              <ArticleCardWrapper context={context} />
            </div>
          );
        }

        return null;
      })}
      <UGCStoriesInfiniteList stories={data} />
    </>
  );
}
